"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledDpTabs = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
exports.StyledDpTabs = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: ", " ", " 0;\n\n  .btn-tab {\n    background: transparent;\n    border: none;\n    padding: ", ";\n    color: ", ";\n    font-size: ", ";\n  }\n\n  .active {\n    color: ", ";\n    border-bottom: 3px solid ", ";\n    font-weight: bold;\n  }\n"], ["\n  padding: ", " ", " 0;\n\n  .btn-tab {\n    background: transparent;\n    border: none;\n    padding: ", ";\n    color: ", ";\n    font-size: ", ";\n  }\n\n  .active {\n    color: ", ";\n    border-bottom: 3px solid ", ";\n    font-weight: bold;\n  }\n"])), function (_a) {
    var Spacing = _a.theme.Spacing;
    return Spacing.x4;
}, function (_a) {
    var Spacing = _a.theme.Spacing;
    return Spacing.x3;
}, function (_a) {
    var Spacing = _a.theme.Spacing;
    return "".concat(Spacing.x1, " ").concat(Spacing.x3, " ").concat(Spacing.x2);
}, function (_a) {
    var Colors = _a.theme.Colors;
    return Colors.Typography.secondary;
}, function (_a) {
    var Typography = _a.theme.Typography;
    return Typography.Sizes.smd;
}, function (_a) {
    var Colors = _a.theme.Colors;
    return Colors.Typography.primary;
}, function (_a) {
    var Colors = _a.theme.Colors;
    return Colors.Indicator.normal;
});
var templateObject_1;
